class Hexagones
{
    constructor()
    {
        this.hexaImages = {};
        this.ratio = 0;
        this.radius = 0;
        this.maxRadius = 20;
        this.init();
        this.initialSetup = true;
    }

    init()
	{
        this.ratio = window.devicePixelRatio || 1;
        //this.ratio = 1;

        window.addEventListener('resize', () => {this.drawHexagones();});
        this.drawHexagones();
	}

    drawHexagones()
    {
        let allCanvas = document.querySelectorAll('.hexagone');
        allCanvas.forEach((hexa) =>
        {
            let canvas = hexa;
            let canvasParent = hexa.parentNode;
            const ctx = canvas.getContext('2d');

            let width = canvasParent.offsetWidth;
            let height = canvasParent.offsetHeight;
            canvas.width = width * this.ratio;
            canvas.height = height * this.ratio;
            canvas.style.width = width + 'px';
            canvas.style.height = height + 'px';
            ctx.scale(this.ratio, this.ratio);

            let largeurCoupure = canvasParent.offsetWidth * .13;
            
            if(canvas.dataset.scale && window.innerWidth > 1024) {
                if(canvas.dataset.scale == "small") {
                    largeurCoupure = 25;
                } else {
                    largeurCoupure = largeurCoupure * canvas.dataset.scale;
                }
            } else if(canvas.dataset.scale_tablet && window.innerWidth > 768 && window.innerWidth <= 1024) {
                if(canvas.dataset.scale_tablet == "small") {
                    largeurCoupure = 25;
                } else {
                    largeurCoupure = largeurCoupure * canvas.dataset.scale_tablet;
                }
            } else if(canvas.dataset.scale_mobile) {

                if(canvas.dataset.scale_mobile == "small") {
                    largeurCoupure = 20;
                } else {
                    largeurCoupure = largeurCoupure * canvas.dataset.scale_mobile;
                }
            }

            if(largeurCoupure > 200) {
                largeurCoupure = 200;
            }

            let hauteurCoupure = largeurCoupure * 0.85;
            
            this.radius = largeurCoupure * .2;
            if(this.radius > this.maxRadius) {
                this.radius = this.maxRadius;
            }

            // let classes = canvas.classList + '';
            // if(classes.includes("hexa-child")) {
            //     let mainCanvas = canvasParent.closest('.row').querySelector('.hexa-parent');
            //     largeurCoupure = (mainCanvas.offsetWidth-80) * .13;
            //     hauteurCoupure = largeurCoupure * 0.85;
            //     this.radius = largeurCoupure * .2;
            //     this.radius = this.radius*0.7;
            //     if(window.innerWidth < 768) {
            //         this.radius = this.radius*0.2;
            //     }
            // }

            let points = [];

            if(canvas.classList.contains('hexa-1-3')) {
                points = [
                    {x: canvasParent.offsetWidth/2, y:0 },
                    {x: canvasParent.offsetWidth, y: 0},
                    {x: canvasParent.offsetWidth, y: canvasParent.offsetHeight - hauteurCoupure},
                    {x: canvasParent.offsetWidth - largeurCoupure, y: canvasParent.offsetHeight},
                    {x: 0, y: canvasParent.offsetHeight},
                    {x: 0, y: hauteurCoupure},
                    {x: largeurCoupure, y:0 }
                ];
                
            } else if(canvas.classList.contains('hexa-2-4')) {
                points = [
                    {x: canvasParent.offsetWidth/2, y:0 },
                    {x: canvasParent.offsetWidth - largeurCoupure, y: 0},
                    {x: canvasParent.offsetWidth, y: hauteurCoupure},
                    {x: canvasParent.offsetWidth, y: canvasParent.offsetHeight},
                    {x: largeurCoupure, y: canvasParent.offsetHeight},
                    {x: 0, y: canvasParent.offsetHeight - hauteurCoupure},
                    {x: 0, y: 0}
                ];

            } else if(canvas.classList.contains('hexa-3')) {
                points = [
                    {x: canvasParent.offsetWidth/2, y:0 },
                    {x: canvasParent.offsetWidth, y: 0},
                    {x: canvasParent.offsetWidth, y: canvasParent.offsetHeight - hauteurCoupure},
                    {x: canvasParent.offsetWidth - largeurCoupure, y: canvasParent.offsetHeight},
                    {x: 0, y: canvasParent.offsetHeight},
                    {x: 0, y: 0}
                ];
            } else if(canvas.classList.contains('hexa-1')) {
                points = [
                    {x: canvasParent.offsetWidth/2, y:0 },
                    {x: canvasParent.offsetWidth, y: 0},
                    {x: canvasParent.offsetWidth, y: canvasParent.offsetHeight},
                    {x: 0, y: canvasParent.offsetHeight},
                    {x: 0, y: hauteurCoupure},
                    {x: largeurCoupure, y: 0}
                ];
            } else if(canvas.classList.contains('hexa-4')) {
                points = [
                    {x: canvasParent.offsetWidth/2, y:0 },
                    {x: canvasParent.offsetWidth, y: 0},
                    {x: canvasParent.offsetWidth, y: canvasParent.offsetHeight},
                    {x: largeurCoupure, y: canvasParent.offsetHeight},
                    {x: 0, y: canvasParent.offsetHeight - hauteurCoupure},
                    {x: 0, y: 0}
                ];
            }

            this.drawRoundedShape(ctx, canvas, points);

        });
    }

    drawRoundedShape(ctx, canvas, points)
    {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.beginPath();
        ctx.moveTo(points[0].x, points[0].y);

        for (let i = 0; i < points.length; i++) {

            const current = points[i];
            const next = points[(i + 1) % points.length];
            const prev = points[(i - 1 + points.length) % points.length];

            const start = {
                x:current.x + (prev.x - current.x) * this.radius / this.distance(current, prev),
                y:current.y + (prev.y - current.y) * this.radius / this.distance(current, prev)
            };

            const end = {
                x:current.x + (next.x - current.x) * this.radius / this.distance(current, next),
                y:current.y + (next.y - current.y) * this.radius / this.distance(current, next)
            };

            ctx.lineTo(start.x, start.y);
            ctx.quadraticCurveTo(current.x, current.y, end.x, end.y);
        }

        ctx.closePath();

        if(canvas.previousElementSibling) {

            ctx.clip();

            let srcImage = canvas.previousElementSibling.src;
            let imageFileName = srcImage.split('/').pop();
            let imgRef = this.hexaImages[imageFileName];

            if(!imgRef) {
                let img = new Image();
                img.src = srcImage;
                img.onload = () => {
                    this.displayImage(img, canvas, ctx);
                };
                this.hexaImages[imageFileName] = img;
            } else {
                this.displayImage(imgRef, canvas, ctx);
            }

        } else {
            //console.log("No image found");
            let bgcolor = canvas.getAttribute('data-bgcolor');
            
            switch(bgcolor) {
                case 'blue':
                    bgcolor = '#2341C1';
                    break;
                case 'white':
                    bgcolor = '#EEF3FA';
                    break;
                case 'green':
                    bgcolor = '#00BFB6';
                    break;
                case 'darkgreen':
                    bgcolor = '#005450';
                    break;
                case 'mauve':
                    bgcolor = '#BFACE7';
                    break;
                case 'jaune':
                    bgcolor = '#F7FA73';
                    break;
                case 'noir':
                    bgcolor = '#1E1E1E';
                    break;
            }

            ctx.fillStyle = bgcolor;
            ctx.fill();
        }
    }

    displayImage(img, canvas, ctx)
    {
        const imgAspectRatio = img.width / img.height;
        const canvasAspectRatio = canvas.width / canvas.height;
        let drawWidth, drawHeight;

        if (imgAspectRatio > canvasAspectRatio) {

            drawWidth = canvas.width;
            drawHeight = canvas.width / imgAspectRatio;

            if(drawHeight < canvas.height) {
                drawHeight = canvas.height;
                drawWidth = canvas.height * imgAspectRatio;
            }

        } else {
            
            drawWidth = canvas.height * imgAspectRatio;
            drawHeight = canvas.height;

            if(drawWidth < canvas.width) {
                drawWidth = canvas.width;
                drawHeight = canvas.width / imgAspectRatio;
            }
        }

        const offsetX = (canvas.width - drawWidth) / 2;
        const offsetY = (canvas.height - drawHeight) / 2;

        ctx.drawImage(img, offsetX/this.ratio, offsetY/this.ratio, drawWidth/this.ratio, drawHeight/this.ratio);
    }

    distance(p1, p2)
    {
        return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
    }

}

export default Hexagones;